import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { callPostApi } from "../../components/API/ApiCallFunction";

const StorePayResponse = () => 
{
  const navigate = useNavigate();
  const calledRef = useRef(false);

  useEffect(() => 
  {
      if (calledRef.current) return;
      calledRef.current = true;

    const sendPgData = async () => {
      try 
      {
        // GET ALL QUERY PARAMS FROM PG
        const params = new URLSearchParams(window.location.search);

        console.log(JSON.stringify(params));

        const payload = Object.fromEntries(params.entries());

        console.log(JSON.stringify(payload));

        // CALL BACKEND API
        const apiResult = await callPostApi("store-pay-success", payload);

        if (String(apiResult?.status) === "200") 
        {
          const status = apiResult?.data?.status || "success";
          const txnid  = apiResult?.data?.txnid || "";
          const amount = apiResult?.data?.amount || "";

          navigate(`/success?status=${encodeURIComponent(status)}&txnid=${encodeURIComponent(txnid)}&amount=${encodeURIComponent(amount)}`,{ replace: true });

          console.log("PG data sent to backend");
        } 
        else 
        {
          navigate("/failure", { replace: true });
        }
      } 
      catch (err) 
      {
        console.error("Payment callback error:", err);
        navigate("/failure", { replace: true });
      }
    };

    sendPgData();
  }, [navigate]);

  return <h3>Processing payment, please wait...</h3>;
};

export default StorePayResponse;
